// extracted by mini-css-extract-plugin
export default {"testSearch":"_1CpV-bHTPBoBt5jxwS26K8","text-map":"_1XZvTx6CA12EdnV8NMVkJL","col-lg-8":"_20St2MIRPG_zb-cdLO-sRi","col-lg-4":"_12tCbZ1_R3d6P6PJFNlTWB","root":"_2LromCzwlvLmAZdHVnyTAc"};